// src/components/Hero/Hero.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLocalContext } from "../../context/LocalContext";
import "./Hero.css";

const Hero = ({ onSubmitLead }) => {
  const { webinfo = {} } = useLocalContext();
  const brandName = webinfo?.name || "webantidigi.com";

  const [form, setForm] = useState({ name: "", phone: "", service: "" });
  const [status, setStatus] = useState({ loading: false, ok: "", err: "" });

  const onChange = (e) => {
    setStatus({ loading: false, ok: "", err: "" });
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      return setStatus({ loading: false, ok: "", err: "Please fill all required fields." });
    }

    try {
      setStatus({ loading: true, ok: "", err: "" });
      await onSubmitLead?.({ ...form, source: "hero_about_theme" });
      setStatus({ loading: false, ok: "We'll contact you shortly.", err: "" });
      setForm({ name: "", phone: "", service: "" });
    } catch {
      setStatus({ loading: false, ok: "", err: "Submission failed. Try again." });
    }
  };

  return (
    <section className="heroAboutTheme">
      <div className="heroAboutTheme-wrap">
        <motion.div
          className="heroAboutTheme-left"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="hero-tag">Full-funnel digital partner</span>

          <h1>
            Digital experiences that <br />
            <span>attract, convert, and retain</span>
          </h1>

          <p>
            {brandName} helps businesses turn traffic into qualified leads with
            high-performing websites, clear messaging, and measurable growth systems.
          </p>

          <ul>
            <li>Positioning and messaging that improves clarity</li>
            <li>Performance, SEO, and tracking built from day one</li>
            <li>Execution support from launch through optimization</li>
          </ul>

          <div className="heroStats">
            <div><strong>50+</strong><span>Projects delivered</span></div>
            <div><strong>4.9★</strong><span>Client satisfaction</span></div>
            <div><strong>&lt;24h</strong><span>Average response</span></div>
          </div>
        </motion.div>

        <motion.div
          className="heroAboutTheme-card"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <h2>Book a free growth review</h2>
          <p>Tell us your goals and current challenges. We will share practical next steps.</p>

          <form onSubmit={handleSubmit}>
            <input
              name="name"
              value={form.name}
              onChange={onChange}
              placeholder="Your name"
            />

            <input
              name="phone"
              value={form.phone}
              onChange={onChange}
              placeholder="Phone number"
            />

            <select
              name="service"
              value={form.service}
              onChange={onChange}
            >
              <option value="">Service you're interested in</option>
              <option>Website Redesign</option>
              <option>SEO Strategy</option>
              <option>Paid Ads & Lead Gen</option>
              <option>Conversion Optimization</option>
            </select>

            {status.err && <div className="heroMsg err">{status.err}</div>}
            {status.ok && <div className="heroMsg ok">{status.ok}</div>}

            <button disabled={status.loading}>
              {status.loading ? "Submitting…" : "Request callback"}
            </button>
          </form>

          <small>Clear scope · Fast turnaround · No pressure sales</small>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
